<template>
   <div class="book-cont" v-loading="bookLoading">    
        <leftNav ref="leftNav" :tabName='"1"' @refresh='refreshList'></leftNav>
        <div class="book">
            <ul class="right-list" >
                <li class="list" v-for="(item,index) in studyList" :key="index">
                    <div class="list-pic">
                        <img :src=item.coverPath alt="" />
                    </div>
                    <div class="list-info">
                        <div class="info-tit">
                            <p class="tit"  > 
                                <a href="javascript:;" v-html=" item.bookName" @click='toPage(item)'> </a> 
                            </p>
                            <p class="txt">作者：{{item.author}}</p>
                            <p class="txt">分类：{{item.classification}}</p>
                            <p class="txt">朝代：{{item.dynasty}}</p>
                            <p class="txt txt-overflow-6">介绍：{{item.introduction}}</p>
                        </div>
                    </div>
                </li>       
            </ul> 
            <el-pagination
                v-if="pageInfo.total>=1"
                @current-change="changePage" 
                :current-page="pageInfo.pageNum" 
                :page-count="pageInfo.pageTotal" 
                :page-size="pageInfo.pageSize" 
                :total="pageInfo.total"
                background
                layout="total, prev, pager, next" >
            </el-pagination>
            <div v-else>
                <p class="no-data">暂无数据</p>
            </div>
        </div>
    </div>
</template>

<script>
import leftNav from './left_nav.vue';
import {mapState,mapMutations } from 'vuex';
import { bookList } from '../../../io/api.js'; 
export default { 
    components:{
        leftNav, 
    },

    data () {
        return { 
            bookLoading:false,
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            studyList:[],
            isShowTip:false,
        }
    },
    computed: {
        ...mapState({
            searchVal: state => state.study.searchVal,
        }),
    },
    mounted(){
        this.getList();
    },
    methods: {
        ...mapMutations([ 'setTabNavNum']),
        // 刷新左侧列表和内容列表
        init(type){ 
            if(type=='refresh'){
                this.$refs.leftNav.getList();
            }
            this.pageInfo.pageNum = 1;
            this.getList();
        },
        // 点击左侧分类
        refreshList(item){ 
            this.pageInfo.pageNum=1;
            this.getList(item); 
        },
        getList(item){   
            this.bookLoading=true;
            let params={
                page: this.pageInfo.pageNum,
                limit: this.pageInfo.pageSize,
                keyWord:this.searchVal,//this.searchVal//
                faceName:item?item.facetName:'',
                faceValue:item?item.type:'',
            }
            bookList(params).then(res => {
                let {code,data,msg}=res.data; 
                if(code==0){
                    this.studyList=data.list||[];
                    this.pageInfo.pageTotal=data.totalPage||1;
                    this.pageInfo.total=data.totalCount||0;
                    // 更新 store 中书目的数量
                    this.setTabNavNum({ type: '1', num: data.totalCount || 0 });
                }else{
                    this.$message.error(msg||'请求失败～');
                }
                this.bookLoading=false;
            })
        },
        changePage(num){
            this.pageInfo.pageNum=num;
            this.getList();
        },
        toPage(item){
            // this.isShowTip=true; 
            // this.$nextTick(()=>{ 
            //     this.$refs.deduct_score.get_studyCheckScoreStatus(item,this.searchVal)
            // })
            // studyBook
            // let url = this.$router.resolve({
            this.$router.push({
				path:'/bookCatalogue',  
				query:{ 
                    id:item.id,
				}
			})  
			// window.open(url.href, '_blank') 
        },
         
    }
}
</script>

<style lang="less" scoped>
    @import url('../study.less');
    .book-cont{
        display: flex;
        justify-content: space-between;
    }
</style>